// Единая точка чтения переменных окружения.
//
// Почему не читать import.meta.env по месту: значения нормализуются (обрезка хвостового
// слэша у базового URL) и в одном месте видно, чего приложению не хватает для запуска.

const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

export const env = {
  /**
   * Базовый URL API из сборки — ЗАПАСНОЙ вариант, не основной.
   *
   * Основной источник — `shared/api/serverAddress` (адрес сервера сети вводит
   * оператор, Фаза 4). Здесь значение непустое только там, где адрес известен
   * заранее: web/nginx-образ (`VITE_API_BASE_URL=/api/v1` в Dockerfile) и
   * локальная разработка через `app/.env.local`. В Android-сборке пусто —
   * это нормальное состояние до первой настройки, а не ошибка конфигурации.
   */
  apiBaseUrl: rawApiBaseUrl.replace(/\/+$/, ''),
  /** DSN Sentry; пустая строка — мониторинг выключен. */
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  mode: import.meta.env.MODE,
  isProduction: import.meta.env.PROD,
} as const;
